import React, { Component } from 'react';
import {
  withRouter,
  getQueryParams,
  setQueryParams,
  objectToQueryString,
} from '../../utils/NavigationWrapper';
import { Timeline as ChartIcon } from '@mui/icons-material';
import { IconButton, Button } from '@mui/material';
import { getInstrumentData } from './ReportRenderer.actions';
import ReportRenderer from './ReportRenderer';
import DialogWrapper from '../DialogWrapper/DialogWrapper';
import Utils from '../../utils/Utils';
import Constants from '../../constants/Constants';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import Store from '../../../redux/Store';
import { setGlobalDateTime } from '../../state/datetime/DateTime.actions';
import { SET_GLOBAL_DATETIME } from '../../state/datetime/DateTime.types';
import { showSnackbar } from '../../state/snackbar/Snackbar.actions';
import { connect } from 'react-redux';
import PermissionsCheck from '../PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../constants/PermissionsEnum';
import { copyTime } from './utils/ReportDateTimeUtils';

const stateFromProps = (props) => ({
  isFetching: true,
  isOpen: props.asDialog,
  query: props.query,
  subreportConfig: { dialogSubreport: { open: false, args: null } },
});

class ReportRendererContainer extends Component {
  constructor(props) {
    super(props);

    if (props != undefined) {
      let urlParams = getQueryParams(props.querySearchParams);
      let newQuery = { ...props.query, ...urlParams };
      let newProps = Object.assign({}, { query: newQuery });
      this.state = stateFromProps(newProps);
    } else {
      this.state = stateFromProps(props);
    }

    this._onQueryChanged = this._onQueryChanged.bind(this);
    this._onShowSubreport = this._onShowSubreport.bind(this);
  }

  componentWillReceiveProps(newProps) {
    let urlParams = getQueryParams(newProps.querySearchParams);
    let query = { ...newProps.query, ...urlParams };
    this._onQueryChanged(query, 'rrcWillReceiveProps');
  }

  componentDidMount() {
    if (this.props.location.search === '') {
      // page reloaded for the first time (no filter applied by the user)
      this._onReloadReport();
    } else {
      this._onReloadReport(true);
    }
  }

  componentDidUpdate(prevProps) {
    let newUrlParams = getQueryParams(this.props.querySearchParams);
    let newQuery = { ...this.props.query, ...newUrlParams };
    if (JSON.stringify(prevProps.query) !== JSON.stringify(newQuery)) {
      if (this.props.location.$reload) {
        this._onReloadReport();
        this.props.location.$reload = false;
      }
    }
  }

  render() {
    if (this.props.asDialog) {
      return (
        <DialogWrapper
          onClickCancel={() => this.setState({ isOpen: false })}
          open={this.state.isOpen}
          hideMainAction={true}
          title={this.state.title || 'Detailed view'}
          maxWidth={'xl'}
        >
          <ReportRenderer
            query={this.state.query}
            isFetching={this.state.isFetching}
            displayComponents={this.state.displayComponents}
            onQueryChanged={this._onQueryChanged}
          />
        </DialogWrapper>
      );
    } else {
      return (
        <ReportRenderer
          query={this.state.query}
          isFetching={this.state.isFetching}
          displayComponents={this.state.displayComponents}
          onQueryChanged={this._onQueryChanged}
          subreportConfig={this.state.subreportConfig}
          onReportItemEvent={this._onReportItemEvent}
        />
      );
    }
  }

  _onReportItemEvent = (params, reason) => {
    switch (reason) {
      case 'expandRows':
        this._expandCallback();
        break;
      case 'collapseRows':
        this._collapseCallback();
        break;
      case 'subreportDialog':
        this._onShowSubreport(params.el, params.supreportDialogArguments);
        break;
      case 'onClickRow':
        let rowOnClickRowAction = this._getTabelRowOnClickRowAction(params.row);
        if (
          params.onClickConfig == 'navigateToReport' ||
          (rowOnClickRowAction != null && rowOnClickRowAction == 'navigateToReport')
        ) {
          const { navigate } = this.props;
          this._onClikNavigateToReport(params.row, navigate);
        }

        if (params.onClickConfig == 'subreport') {
          this._onClickRow(params.row);
        }

        if (params.onClickConfig == 'cellSubreport') {
          const { navigate, onCellClick } = this.props;
          onCellClick(params, navigate);
        }

        break;
    }
  };

  _onQueryChanged = (queryChanges, reason) => {
    let query = { ...this.state.query, ...queryChanges };
    if (query && !Utils.shallowCompare(query, this.state.query)) {
      let { $reload, ...newQuery } = query;
      let $clearQuery =
        query.ReportName != this.state.query.ReportName ||
        query.SelectedInstrument != this.state.query.SelectedInstrument;

      let fleetChanged =
        query.SelectedFleet != undefined &&
        this.state.query.SelectedFleet != undefined &&
        query.SelectedFleet != this.state.query.SelectedFleet;

      if ($clearQuery || fleetChanged) {
        if (fleetChanged) {
          newQuery = {
            ReportName: newQuery.ReportName,
            SelectedFleet: newQuery.SelectedFleet,
          };
        } else {
          newQuery = {
            ReportName: newQuery.ReportName,
            SelectedInstrument: newQuery.SelectedInstrument,
          };
        }

        if (
          this.props.globalDateTime != null &&
          this.props.globalDateTime.startDate != undefined &&
          this.props.globalDateTime.endDate != undefined
        ) {
          newQuery.StartDate = this.props.globalDateTime.startDate;
          newQuery.EndDate = this.props.globalDateTime.endDate;
        }

        $reload |= reason === 'rrcWillReceiveProps';
      }

      this.setState({ query: newQuery }, () => {
        setQueryParams(newQuery, this.props.querySearchParams, this.props.setQuerySearchParams, {
          replace: true,
        });

        if ($reload) {
          if (reason.includes('filter')) {
            this._onReloadReport(true);
          } else {
            this._onReloadReport();
          }
        }
      });
    }
  };

  _onReloadReport = (fromFilter) => {
    let query = this.state.query;
    var hasReportChanged =
      this.props.globalDateTime == null
        ? false
        : this.props.globalDateTime.setByReportName != this.state.query.ReportName;

    this.setState({ isFetching: true });

    if (
      this.state.query.StartDate == undefined &&
      this.state.query.EndDate == undefined &&
      this.props.globalDateTime != null &&
      this.props.globalDateTime.startDate != undefined &&
      this.props.globalDateTime.endDate != undefined
    ) {
      query.StartDate = this.props.globalDateTime.startDate;
      query.EndDate = this.props.globalDateTime.endDate;
    }

    getInstrumentData(query, this.props.useCache)
      .then((res) => {
        let splittedUrl = this.props.location.pathname.split('/');
        let lastParamFromUrl = splittedUrl[splittedUrl.length - 1].split('-');
        let reportName =
          lastParamFromUrl != undefined
            ? lastParamFromUrl.some((el) => el === 'fleet')
              ? lastParamFromUrl[2]
              : lastParamFromUrl[1]
            : undefined;

        if (reportName != undefined && reportName !== query.ReportName && fromFilter !== true) {
          return;
        }

        let newState = { ...this.state, query, isFetching: false };

        if (res.body) {
          newState.displayComponents = res.body || [];

          //wanted to have this in the Filter component but had update loop issues, try again to move it there in the future:
          //if the server computes new query, update the existing query to this new one:
          let filterComponentWithQueryFeedback = newState.displayComponents.find(
            (dc) => dc.Type === 'Filter' && dc.Configuration && dc.Configuration.query
          );
          newState.query =
            (filterComponentWithQueryFeedback
              ? filterComponentWithQueryFeedback.Configuration.query
              : undefined) ||
            newState.query ||
            {};
        }

        this.setState(newState, () => {
          this._saveDateTime();
          setQueryParams(
            newState.query,
            this.props.querySearchParams,
            this.props.setQuerySearchParams,
            {
              replace: true,
            }
          );
        });
      })
      .catch((e) => this.setState({ query }))
      .finally(() => this.setState({ isFetching: false }));
  };

  _saveDateTime = () => {
    let filterComponent = this.state.displayComponents.find((dc) => dc.Type === 'Filter');

    if (
      filterComponent != undefined &&
      filterComponent.Configuration.fields.some((el) => el.type.includes('Time'))
    ) {
      let timeConfigFields = filterComponent.Configuration.fields;
      let startType = timeConfigFields.find((el) => el.type.includes('Time')).mode.startType;
      let endType = timeConfigFields.find((el) => el.type.includes('Time')).mode.endType;

      let newDateFrom = moment.utc(this.state.query.StartDate);
      let newDateTo = moment.utc(this.state.query.EndDate);
      let reportName = this.state.query.ReportName;

      //if the report doesn't have date and time selection,
      //save only the new date and get from redux the old time
      if (
        this.props.globalDateTime != null &&
        this.props.globalDateTime.startDate != undefined &&
        startType != 'dateTime' &&
        endType != 'dateTime'
      ) {
        let newDate = copyTime(
          this.props.globalDateTime.startDate,
          this.props.globalDateTime.endDate,
          newDateFrom,
          newDateTo
        );
        newDateFrom = newDate.dateFrom;
        newDateTo = newDate.dateTo;
      }

      Store.dispatch(
        setGlobalDateTime({
          type: SET_GLOBAL_DATETIME,
          startDate: newDateFrom.format(),
          endDate: newDateTo.format(),
          setByReportName: reportName,
        })
      );
    } else if (
      !this.props.globalDateTime &&
      this.state.query.StartDate &&
      this.state.query.EndDate
    ) {
      Store.dispatch(
        setGlobalDateTime({
          type: SET_GLOBAL_DATETIME,
          startDate: this.state.query.StartDate,
          endDate: this.state.query.EndDate,
          setByReportName: this.state.query.ReportName,
        })
      );
    }
  };

  _createTableSubreportTemplates = (colConfigs) => {
    return colConfigs.map((colConfig) => {
      let type = colConfig.type;
      if (type && type.startsWith('SubreportDialog')) {
        colConfig.type = 'markup';
        colConfig.markup = (el, col, elIndex, colIndex) => {
          return (
            <IconButton
              size="large"
              onClick={this._onShowSubreport(el, col.arguments)}
              style={{
                width: 'auto',
                height: 'auto',
                padding: 0,
              }}
              data-qa="qa-chart-table"
            >
              <ChartIcon />
            </IconButton>
          );
        };
      }
      return colConfig;
    });
  };

  _onShowSubreport = (el, args) => {
    let argsObj = args.reduce((acc, cv) => {
      acc[cv.keyName] = cv.value || el[cv.valueName] || this.state.query[cv.valueName];
      return acc;
    }, {});
    let subreportConfig = Object.assign({}, this.state.subreportConfig, {
      dialogSubreport: { open: true, args: argsObj, onClose: this._onHideSubreport },
    });

    this.setState({
      subreportConfig,
    });
  };

  _onHideSubreport = () => {
    let subreportConfig = Object.assign({}, this.state.subreportConfig, {
      dialogSubreport: { open: false, args: null },
    });

    this.setState({
      subreportConfig,
    });
  };

  _updateTableData = (newTableData, query) => {
    let newTableConfig = {
      ...this.state.displayComponents.find((el) => el.Type == 'Table'),
    };
    newTableConfig.Data = newTableData;

    this.setState({
      displayComponents: this.state.displayComponents.map((el) =>
        el.Type == 'Table' ? newTableConfig : el
      ),
      query,
    });
  };

  _updateColumnConfiguration = (newColumnConfig) => {
    let newTableConfig = {
      ...this.state.displayComponents.find((el) => el.Type == 'Table'),
    };
    newTableConfig.Configuration.columnsConfig = newColumnConfig;

    this.setState({
      displayComponents: this.state.displayComponents.map((el) =>
        el.Type == 'Table' ? newTableConfig : el
      ),
    });
  };

  _updateFilterConfiguration = (newFilterDisplayConfiguration) => {
    let filterConfig = {
      ...this.state.displayComponents.find((el) => el.Type == 'Filter'),
    };
    filterConfig.Configuration = newFilterDisplayConfiguration;

    this.setState({
      displayComponents: this.state.displayComponents.map((el) =>
        el.Type == 'Filter' ? filterConfig : el
      ),
    });
  };

  _onClickRow = (row, expandCollapseCallback = false) => {
    let currentTableConfig = this.state.displayComponents.find((el) => el.Type == 'Table');
    let currentTableData = currentTableConfig.Data;
    let columnsConfig = currentTableConfig.Configuration.columnsConfig;
    let data = currentTableData;
    let query = this.state.query;
    let onClickConfig = currentTableConfig.Configuration.onClickRowAction;

    if (onClickConfig === 'subreport' && row.Subreport && !this.state.isFetching) {
      if (!row.Subreport.clicked) {
        let newReportQuery = {
          SelectedInstrument: query.SelectedInstrument,
          StartDate: query.StartDate,
          EndDate: query.EndDate,
        };

        newReportQuery = { ...newReportQuery, ...row['Subreport'] };

        //give a unique key to the row, so that it can be collapsed
        let selectedRowIndex = data.indexOf(row);
        data[selectedRowIndex].rowKey = data[selectedRowIndex].rowKey || uuidv4();
        data[selectedRowIndex].Subreport = {
          ...data[selectedRowIndex].Subreport,
          isFetching: true,
        };

        //set the isFetching to true for the row
        this._updateTableData(data, query);

        this.setState({
          isFetching: true,
        });

        //get the new data for the row
        getInstrumentData(newReportQuery, this.props.useCache)
          .then((res) => {
            let reportResult = res.body.find((el) => el.Type == 'Rows');
            let filterConfig = res.body.find((el) => el.Type == 'Filter').Configuration;
            let newData = reportResult.Data;

            if (newData.length == 0) {
              data[selectedRowIndex].Subreport = {
                ...data[selectedRowIndex].Subreport,
                isFetching: false,
              };
              this._updateTableData(data, query);
              this._showFailMessage('No data to show.');
            } else {
              //check if columns need to be made visible
              let newColumns =
                reportResult.Configuration != undefined
                  ? reportResult.Configuration.columnsConfig
                  : null;

              if (newColumns != null && newColumns != undefined && newColumns.length != 0) {
                let hiddenColumns = columnsConfig.filter(
                  (config) =>
                    config.visible == false && newColumns.some((el) => el.key == config.key)
                );

                if (hiddenColumns.length > 0) {
                  hiddenColumns.map((colConfig) => {
                    if (newData.some((el) => el[colConfig.key] != undefined)) {
                      if (colConfig.visible == false) {
                        colConfig.visible = true;
                      }
                    }
                  });

                  this._updateColumnConfiguration(columnsConfig);
                }
              }

              //insert new data to existing data
              newData.map((el, newRowIndex) => {
                el = {
                  ...el,
                  subRowOf: data[selectedRowIndex].rowKey,
                  rowConfig: reportResult.Configuration,
                };
                data.splice(selectedRowIndex + newRowIndex + 1, 0, el);
              });

              data[selectedRowIndex].Subreport = {
                ...data[selectedRowIndex].Subreport,
                clicked: true,
                nrOfSubRows: newData.length,
                isFetching: false,
              };
              this._updateTableData(data, query);

              if (filterConfig.metadata.HasMoreData) {
                this._updateFilterConfiguration(filterConfig);
              }
            }

            if (expandCollapseCallback) {
              this.setState(
                {
                  isFetching: false,
                },
                () => this._expandCallback()
              );
            } else {
              this.setState({
                isFetching: false,
              });
            }
          })
          .catch((e) =>
            this.setState({
              isFetching: false,
            })
          );
      } else {
        //collapse selected row and remove data that were a child item of that row
        let selectedRowIndex = data.indexOf(row);
        let rowsToKeep = [];

        if (data[selectedRowIndex].Subreport.nrOfSubRows > 0) {
          let rowsToRemove = [];
          this._collapse(data, data[selectedRowIndex].rowKey, rowsToRemove);
          rowsToKeep = data.filter((x) => !rowsToRemove.includes(x));

          let newSelectedIndex = rowsToKeep.indexOf(row);
          rowsToKeep[newSelectedIndex].Subreport = {
            ...data[newSelectedIndex].Subreport,
            clicked: false,
            nrOfSubRows: 0,
          };
          this._updateTableData(rowsToKeep, query);
          if (expandCollapseCallback) {
            this.setState({}, () => this._collapseCallback());
          }
        }
      }
    }
    //other cases like: onClickConfig === 'redirect'
  };

  _getTabelRowOnClickRowAction = (row) => {
    return row.rowConfig != undefined && row.rowConfig.onClickRowAction != undefined
      ? row.rowConfig.onClickRowAction
      : null;
  };

  _collapse = (data, searchIndex, matches) => {
    let rowsToRemove = data.filter((el) => el.subRowOf != undefined && el.subRowOf == searchIndex);

    if (rowsToRemove.length != 0) {
      rowsToRemove.forEach((el, index) => {
        matches.push(el);
        if (
          el.Subreport != undefined &&
          el.Subreport.nrOfSubRows != undefined &&
          el.Subreport.nrOfSubRows > 0
        ) {
          this._collapse(data, el.rowKey, matches);
        }
      });
    }
  };

  _expandCallback = () => {
    let currentTableConfig = this.state.displayComponents.find((el) => el.Type == 'Table');
    let currentTableData = currentTableConfig.Data;
    let rowToExpand = currentTableData.find((el) => el.Subreport && !el.Subreport.clicked);

    if (rowToExpand != undefined) {
      this._onClickRow(rowToExpand, true);
    } else {
      this._showSuccessMessage('Expand rows completed sucessfully.');
    }
  };

  _collapseCallback = () => {
    let currentTableConfig = this.state.displayComponents.find((el) => el.Type == 'Table');
    let currentTableData = currentTableConfig.Data;
    let rowToCollapse = currentTableData.find((el) => el.Subreport && el.Subreport.clicked);

    if (rowToCollapse != undefined) {
      this._onClickRow(rowToCollapse, true);
    } else {
      this._showSuccessMessage('Collapse rows completed sucessfully.');
    }
  };

  _onClikNavigateToReport = (row, navigate) => {
    let query = this.state.query;
    let newReportQuery = {
      SelectedInstrument: query.SelectedInstrument,
      StartDate: query.StartDate,
      EndDate: query.EndDate,
    };

    let path = window.location.pathname;

    if (row['NavigateToReportQuery'] != undefined) {
      newReportQuery = { ...newReportQuery, ...row['NavigateToReportQuery'] };
    }

    if (row['NavigateToReportPath'] != undefined) {
      path = row['NavigateToReportPath'];
    }

    navigate(`${path}?${objectToQueryString(newReportQuery)}`, {
      replace: true,
    });

    window.location.reload();
  };

  _showFailMessage(theMessage, err) {
    let messageToShow = theMessage;
    if (err != null) {
      messageToShow +=
        err.response && err.response.body.Message
          ? err.response.body.Message
          : Constants.DEFAULT_ERROR_MESSAGE;
    }

    Store.dispatch(
      showSnackbar({
        type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
        message: messageToShow,
      })
    );
  }

  _showSuccessMessage(theMessage) {
    Store.dispatch(
      showSnackbar({
        type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
        message: theMessage,
      })
    );
  }
}

const mapStateToProps = (state) => ({
  globalDateTime: state.globalDateTime ? state.globalDateTime : null,
});

export default withRouter(connect(mapStateToProps)(ReportRendererContainer));
